import React from 'react';
import Image from 'next/image';

interface Metrics {
  galeria?: {
    url?: string;
  };
  metricas?: string;
  metricas_highlight?: string;
}

interface HeroMetricsProps {
  metrics?: Metrics;
}

export const HeroMetrics: React.FC<HeroMetricsProps> = ({ metrics }) => {
  if (!metrics || (!metrics.galeria?.url && !metrics.metricas)) {
    return null;
  }

  const renderMetricsText = () => {
    if (!metrics.metricas || !metrics.metricas_highlight) {
      return metrics.metricas;
    }

    const metricasText = metrics.metricas;
    const highlightPhrase = metrics.metricas_highlight;

    if (!highlightPhrase || !metricasText.includes(highlightPhrase)) {
      return metricasText;
    }

    const parts = metricasText.split(highlightPhrase);

    return (
      <>
        {parts[0]}
        <span className="text-[#8BC34A] font-bold">{highlightPhrase}</span>
        {parts[1]}
      </>
    );
  };

  return (
    <div className="flex flex-col sm:flex-row items-center gap-3 mt-6 lg:mt-4 z-1">
      {/* Imagem da Métrica */}
      {metrics.galeria?.url && (
        <div className="flex items-center gap-2">
          <div className="flex-shrink-0 relative">
            <Image
              src={metrics.galeria.url}
              alt="Métrica"
              width={100}
              height={100}
              className="object-cover"
            />
          </div>
        </div>
      )}

      {/* Texto de Métricas */}
      {metrics.metricas && metrics.metricas_highlight && (
        <div className="text-center sm:text-left">
          <p className="text-sm font-semibold text-[#2C2C2C]">
            {renderMetricsText()}
          </p>
        </div>
      )}
    </div>
  );
};
